import { Component, Vue, Prop as prop} from 'nuxt-property-decorator';

@Component({
    components: {
       rangeSlider: require('~/components/form/range/').default,
    },
})
export default class CatalogSliderFilterComponent extends Vue {

    @prop()
    private value: CatalogFilterField;

    @prop()
    public opened: boolean;

    get labelClass() {
        if (this.value.code === 'price') {
            return 'currency';
        }

        return '';
    }
    
    get changed() {
        return this.value.values[0] > this.value.bounds[0] || this.value.values[1] < this.value.bounds[1];
    }
}
